import { type MutationHookOptions, useMutation } from "@apollo/client";
import { UpdatePromocodeMutation } from "../graphql/mutations";
import type {
  UpdatePromocodeMutationType,
  UpdatePromocodeMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useUpdatePromocodeMutation = (
  options?: MutationHookOptions<
    UpdatePromocodeMutationType,
    UpdatePromocodeMutationVariablesType
  >
) => {
  return useMutation<
    UpdatePromocodeMutationType,
    UpdatePromocodeMutationVariablesType
  >(UpdatePromocodeMutation, options);
};
